












import Vue from 'vue';
import UserMenuMobileSubMenuUser from '@/components/global/UserMenuMobile/UserMenuMobileSubMenu/UserMenuMobileSubMenuUser/UserMenuMobileSubMenuUser.vue';
import UserMenuMobileSubMenuReferralButton from '@/components/global/UserMenuMobile/UserMenuMobileSubMenu/UserMenuMobileSubMenuReferralButton.vue';
import UserMenuMobileSubMenuProfileLinks from '@/components/global/UserMenuMobile/UserMenuMobileSubMenu/UserMenuMobileSubMenuProfileLinks/UserMenuMobileSubMenuProfileLinks.vue';

export default Vue.extend({
  name: 'UserMenuMobileSubMenu',
  components: {
    UserMenuMobileSubMenuUser,
    UserMenuMobileSubMenuReferralButton,
    UserMenuMobileSubMenuProfileLinks,
    HeaderAnonymousProfile: () =>
      import('@/components/global/HeaderMenu/HeaderAnonymousProfile/HeaderAnonymousProfile.vue'),
  },
});
